import React from 'react';
import PropTypes from 'prop-types';
import Logo from '../../assets/images/logo/logo_dark.png';
import './styles.scss';

PageLoader.propTypes = {
    text: PropTypes.string,
};

function PageLoader({ text }) {
    return (
        <div className="tf-page-loader">
            <div className="tf-page-loader-inner">
                <div className="tf-page-loader-logo">
                    <img src={Logo} alt="Al-Jariyah" />
                </div>

                <div className="tf-page-loader-spinner">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>

                <p className="tf-page-loader-text">{text}</p>
            </div>
        </div>
    );
}

PageLoader.defaultProps = {
    text: 'Sedang memuatkan maklumat...',
};

export default PageLoader;
